import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";
import { useCart } from "../../context/CartContext";
import { toast } from "sonner";

export default function ProductDetail() {
  const { id } = useParams();
  const { t, localize, fmtSAR } = useI18n();
  const { add } = useCart();
  const [p, setP] = useState(null);
  const [qty, setQty] = useState(1);
  useEffect(() => { api.get(`/products/${id}`).then((r) => setP(r.data)).catch(() => {}); }, [id]);
  if (!p) return <div className="py-20 text-center text-slate-400">{t("common.loading")}</div>;
  return (
    <div className="mx-auto max-w-5xl px-4 py-12 sm:px-8">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
        <div className="overflow-hidden rounded-3xl"><img src={p.image} alt="" className="w-full object-cover" /></div>
        <div>
          <h1 className="text-3xl font-bold text-slate-900">{localize(p, "name")}</h1>
          <div className="mt-3 text-2xl font-extrabold text-primary">{fmtSAR(p.price)}</div>
          <p className="mt-2 text-xs text-slate-400 font-mono">SKU: {p.sku}</p>
          <div className="mt-6 flex items-center gap-3">
            <div className="flex items-center rounded-full border border-border">
              <button onClick={() => setQty((q) => Math.max(1, q - 1))} className="px-4 py-2 text-lg">−</button>
              <span className="w-8 text-center font-semibold" data-testid="product-qty">{qty}</span>
              <button onClick={() => setQty((q) => q + 1)} className="px-4 py-2 text-lg">+</button>
            </div>
            <button onClick={() => { add(p, qty); toast.success(t("common.add")); }} data-testid="product-add-cart" className="flex-1 rounded-full bg-primary py-3 font-semibold text-white hover:bg-primary/90 active:scale-95">{t("nav.cart")}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
